module.exports = __webpack_public_path__ + "static/referencement-seo-som.43045758.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/referencement-seo-som.png
// module id = 813
// module chunks = 59393608157790